/**
 * Commonly repeated Tailwind class combinations
 *
 * These classes are used throughout the admin dashboard and should be
 * kept consistent. For brandable colors, prefer using semantic classes
 * like bg-primary that reference CSS variables from BrandingProvider.
 */

/**
 * Card container styles - white background with border, rounded corners, and shadow
 */
export const CARD_CLASSES =
  "bg-card border border-[rgba(17,31,17,0.1)] rounded-[12px] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)] p-[24px]";

/**
 * Input field styles - light background with border and rounded corners
 */
export const INPUT_CLASSES = "bg-[#f5f9f3] border border-[rgba(17,31,17,0.1)] rounded-[8px]";

/**
 * Primary button styles - uses bg-primary for branding support
 * Falls back to default green if branding unavailable
 */
export const BUTTON_PRIMARY_CLASSES =
  "bg-primary text-primary-foreground rounded-[8px] min-w-[82px]";

/**
 * Info/alert box styles - light green background with border
 */
export const INFO_BOX_CLASSES = "bg-[#e8f5d8] border border-[rgba(101,193,9,0.2)] rounded-[8px]";

/**
 * Alternative info box styles - very light green background
 */
export const INFO_BOX_ALT_CLASSES =
  "bg-[#f0f9e8] border border-[rgba(101,193,9,0.2)] rounded-[8px]";
